import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import PropTypes from "prop-types";

import { ModalDialog, LoginLoading } from "@onelogin/react-components";
import ShareModalContent from "./ShareModalContent";

import {
  fetchCurrentNoteGrants,
  resetGrants
} from "../../actions/grantsActions";
import { NARROW_VIEW_LIMIT } from "../../constants/Env";

class ShareModal extends Component {
  componentDidMount() {
    this.props.fetchCurrentNoteGrants(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.resetGrants();
  }

  render = () => {
    const {
      loading,
      userGranted,
      roleGranted,
      userList,
      roleList,
      onCloseShareModal
    } = this.props;
    return (
      <ModalDialog
        fixedWidth={NARROW_VIEW_LIMIT}
        onClose={onCloseShareModal}
        closeOnEscape
        closeOnClick
      >
        {!loading ? (
          <ShareModalContent
            onCloseShareModal={onCloseShareModal}
            userGranted={userGranted}
            roleGranted={roleGranted}
            userList={userList}
            roleList={roleList}
          />
        ) : (
          <LoginLoading />
        )}
      </ModalDialog>
    );
  };
}

ShareModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  userGranted: PropTypes.array,
  roleGranted: PropTypes.array,
  userList: PropTypes.array,
  roleList: PropTypes.array
};

const mapStateToProps = state => ({
  loading: state.grants.loading,
  userGranted: state.grants.userGranted,
  roleGranted: state.grants.roleGranted,
  userList: state.grants.userList,
  roleList: state.grants.roleList
});

const mapDispatchToProps = dispatch => ({
  fetchCurrentNoteGrants: id => {
    dispatch(fetchCurrentNoteGrants(id));
  },
  resetGrants: () => {
    dispatch(resetGrants());
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ShareModal)
);
